import { useState, useCallback, useRef, useEffect } from 'react';

export function useLocalStorage(key, initialValue) {
  // Use ref to always have latest value for the callback
  const storedValueRef = useRef();
  
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      const value = item ? JSON.parse(item) : initialValue;
      storedValueRef.current = value;
      return value;
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error);
      storedValueRef.current = initialValue;
      return initialValue;
    }
  });

  // Keep ref in sync
  useEffect(() => {
    storedValueRef.current = storedValue;
  }, [storedValue]);

  const setValue = useCallback((value) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore = value instanceof Function ? value(storedValueRef.current) : value;
      setStoredValue(valueToStore);
      storedValueRef.current = valueToStore;
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error);
    }
  }, [key]);

  return [storedValue, setValue];
}

export const DEFAULT_PROFILE = {
  name: '',
  company: '',
  phone: '',
  email: ''
};
